import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import RadioNode from './RadioNode'
import RadioConfig from './RadioConfig'

registerNodeType({
  type: 'RADIO',
  label: 'Radio',
  icon: ICONIFY.RADIO,
  color: '#4A90D9',
  hasOptions: true,
  excludeFields: ['inputMode', 'inputRegex', 'minSize', 'maxSize'],
  defaults: { minSize: 1, maxSize: 1, answerOptionList: null },
  nodeComponent: RadioNode,
  configComponent: RadioConfig,
})
